import { useState, useEffect } from "react";
import AdminConcerts from "../components/admin/AdminConcerts";
import AdminProjects from "../components/admin/AdminProjects";
import AdminPortfolio from "../components/admin/AdminPortfolio";
import AdminPerformances from "../components/admin/AdminPerformances";
import AdminTexts from "../components/admin/AdminTexts";
import AdminImages from "../components/admin/AdminImages";
import AdminCollection from "../components/admin/AdminCollection";

export default function Admin({ setIsAdmin }) {

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 990);
  const [activeSection, setActiveSection] = useState("concerts");

  const logout = () => {
    fetch('/api/logout.php', { credentials: 'include' })
      .then(() => setIsAdmin(false));
  };

  const renderSection = () => {
    switch (activeSection) {
      case "concerts":
        return <AdminConcerts />;
      case "projects":
        return <AdminProjects />;
      case "photos":
        return <AdminPortfolio />;
      case "performances":
        return <AdminPerformances />;
      case "texts":
        return <AdminTexts />;
      case "images":
        return <AdminImages />;
      case "collection":
        return <AdminCollection />;
      default:
        return null;
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 990);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <main className="page-container bg-custom">
      <div className="admin-layout">

        {/* SIDEBAR FIXE */}
        <aside className="admin-sidebar">
          <h4 className="mb-4">Administration</h4>

          <button className="shadow" onClick={() => setActiveSection("concerts")}>Concerts</button>
          <button className="shadow" onClick={() => setActiveSection("projects")}>Projets</button>
          <button className="shadow" onClick={() => setActiveSection("photos")}>Photos</button>
          <button className="shadow" onClick={() => setActiveSection("performances")}>Performances</button>
          <button className="shadow" onClick={() => setActiveSection("texts")}>Textes</button>
          <button className="shadow" onClick={() => setActiveSection("images")}>Images</button>
          <button className="shadow" onClick={() => setActiveSection("collection")}>Collection</button>

          <button className="logout-btn shadow" onClick={logout}>
            Déconnexion
          </button>
        </aside>

        {/* CONTENU */}
        <section className="admin-content">
          {isMobile ? (
            <>
              <AdminConcerts />
              <AdminProjects />
              <AdminPortfolio />
              <AdminPerformances />
              <AdminTexts />
              <AdminImages />
              <AdminCollection />
            </>
          ) : (
            renderSection()
          )}
        </section>

      </div>
    </main>
  );
}